import { ThemeContext } from './Http';
import { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
    caption: {
        color: "#2182B8",
        fontSize: "24px",
    },
    value: {
        fontSize: '24px',
    }
})

function CustomerService (props) {
    const session = useContext(ThemeContext);
    const { t } = useTranslation();

    const classes = useStyles();

    const cs = [];
    let hasManufacture = false;
    if (session.Distributors) {
        session.Distributors.forEach((c) => {
            if (c.Category === 2) {
                hasManufacture = true
            }
            cs.push(
                <div style={{
                    margin: "5px",
                }}>
                    <div style={{
                        
                    }}>
                        <span className={classes.caption}>{c.Category===2 ? t("Manufacturer") : c.Category===1 ? t("Installer") : t("Distributor")}:&nbsp;</span>
                        <span className={classes.value}>{c.Name||""}</span>
                    </div>
                    <div style={{
                        
                    }}>
                        <span className={classes.caption}>{t("Phone")}:&nbsp;</span>
                        <span className={classes.value}>{c.Phone||""}</span>
                    </div>
                    <div style={{
                        borderBottom: '1px solid #2182B8',
                        paddingBottom: '5px',
                    }}>
                        <span className={classes.caption}>{t("E-Mail")}:&nbsp;</span>
                        <span className={classes.value}>{c.EMail||""}</span>
                    </div>
                </div>
            )
        });
    }
    const c = session.CustomerService || {};
    if (!hasManufacture) {
        cs.push(
            <div style={{
                margin: "5px",
            }}>
                <div style={{
                    
                }}>
                    <span className={classes.caption}>{t("Manufacturer")}:&nbsp;</span>
                    <span className={classes.value}>{c.Name||""}</span>
                </div>
                <div style={{
                    
                }}>
                    <span className={classes.caption}>{t("Phone")}:&nbsp;</span>
                    <span className={classes.value}>{c.Phone||""}</span>
                </div>
                <div style={{

                }}>
                    <span className={classes.caption}>{t("E-Mail")}:&nbsp;</span>
                    <span className={classes.value}>{c.EMail||""}</span>
                </div>
            </div>
        )
    }

    return (
        <div style={{
            width: '100%',
            height: '100%',
            position: 'relative',
        }}>
            <img src="/images/customer_bg.png" alt={t("Customer background")} width="100%" height="100%" />
            <div style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                zIndex: 100,
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'rgba(239, 248, 254, 0.8)',
                borderRadius: '20px',
                padding: '80px',
                textAlign: 'center',
            }}>
                {cs}
            </div>
        </div>
    )
}

export default CustomerService;